import React, { Component, Fragment } from 'react';
import Piechart from '../charts/Piechart';
import Table from './Table';
import Splinechart from '../charts/Splinechart';
import Tableservers from '../servers/Tableservers';
import Can from '../../config/Can';

class Content extends Component {

    constructor(props) {
        super(props)
        this.Can = new Can();
        this.datauser = JSON.parse(localStorage.getItem("ls")) || [];
    }

    render() {

        return (
            <Fragment>
                <div id="content">
                    <div className="c-row">
                        <div className="container">
                            <div className="row">

                                <div className="col-md-4">
                                    <div className="card bg-white mb-3 card-primary">
                                        <div className="card-body">
                                            <h5 className="card-title">${this.props.dashboard.saldo}</h5>
                                            {this.Can.show(this.datauser.perm) ?
                                                <p className="card-text">Crédito total de usuarios</p>
                                                :
                                                <p className="card-text">Crédito restante.</p>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="card bg-white mb-3 card-danger">
                                        <div className="card-body">
                                            <h5 className="card-title">{this.props.dashboard.m_enviados}</h5>
                                            <p className="card-text">Total mensajes enviados.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="card bg-white mb-3 card-warning">
                                        <div className="card-body">
                                            <h5 className="card-title">{this.props.dashboard.m_recibidos}</h5>
                                            <p className="card-text">Total mensajes recibidos.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="c-row">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="card bg-white mb-3 card-success">
                                        <div className="card-body">
                                            <h5 className="card-title">{this.props.dashboard.total}</h5>
                                            <p className="card-text">Campañas activas.</p>
                                        </div>
                                    </div>
                                    <div className="c-row">
                                        {this.props.dashboard.m_enviados !== 0 ?
                                            <Piechart
                                                enviados={this.props.dashboard.m_enviados}
                                                recibidos={this.props.dashboard.m_recibidos} />
                                            :
                                            <div className="alert alert-info">
                                                <p className="text-white">Aún no tienes mensajes enviados o recibidos</p>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="col-md-8">
                                    <h4 className="text-center">Lista de campañas</h4>
                                    <div className="max-overflow-300">
                                        <Table campañas={this.props.dashboard.campañas} />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>


                    <div className="mt-5"></div>
                    {this.Can.show(this.datauser.perm) &&
                        <div className="c-row">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="dashboard-panel">
                                            <Splinechart

                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="mt-5"></div>
                    {this.Can.show(this.datauser.perm) &&

                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="dashboard-panel">
                                        <Tableservers
                                            listaServidores={this.props.dashboard.servidores} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                </div>
            </Fragment >
        );
    }
}

export default Content;


// WEBPACK FOOTER //
// ./src/components/dashboard/Content.js